module.exports = __webpack_public_path__ + "img/Klaas_profilePicture.58ca780e.jpg";